import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';
import moment from 'moment-timezone';
import useEducatorsWhoCompletedProject from './useEducatorsWhoCompletedProject';
import useEducatorsAffiliatedWithNetworkSite from './useEducatorsAffiliatedWithNetworkSite';

export default function EducatorsWithOpenProject(props) {
  const { network, schoolStart, schoolEnd, currentTimestamp, titleOnly = false } = props;

  const title = `% of educators who shared a project`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousCreatedProject = useEducatorsWhoCompletedProject(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newCreatedProject = useEducatorsWhoCompletedProject(network, {
    start: schoolStart,
    end: schoolEnd
  });

  const previousAffiliatedNetworkSite = useEducatorsAffiliatedWithNetworkSite(network, {
    end: titleOnly ? undefined : schoolStart
  }, currentTimestamp);

  const newAffiliatedNetworkSite = useEducatorsAffiliatedWithNetworkSite(network, {
    end: schoolEnd
  }, currentTimestamp);

  if (
    previousCreatedProject.state === PayloadStates.FETCHING ||
    newCreatedProject.state === PayloadStates.FETCHING ||
    previousAffiliatedNetworkSite.state === PayloadStates.FETCHING ||
    newAffiliatedNetworkSite.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  const newPercent = Math.ceil(newCreatedProject.meta.totalCount / newAffiliatedNetworkSite.meta.totalCount * 100);
  const previousPercent = Math.ceil(previousCreatedProject.meta.totalCount / previousAffiliatedNetworkSite.meta.totalCount * 100);

  return (
    <ComparisonMetric
      name={title}
      value={newPercent}
      previousValue={previousPercent}
      titleOnly={titleOnly}
      percent={true}
    />
  );
}

EducatorsWithOpenProject.propTypes = {
  network: PropTypes.object.isRequired,
  schoolStart: PropTypes.string.isRequired,
  schoolEnd: PropTypes.string.isRequired,
  currentTimestamp: PropTypes.string.isRequired,
  titleOnly: PropTypes.bool
};
